<script>
import store from '@state/store'
import { debounce } from 'debounce'
import PostFeed from '@router/components/post-feed.vue'

export default {
  components: {
    PostFeed,
  },
  props: {
    challenge: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    teamName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      groupMember: 0,
      filters: {
        name: '',
        email: '',
      },
      groupMembersList: [],
      loadingMore: false,
      noMorePosts: false,
    }
  },
  computed: {
    groupId() {
      return this.group.id
    },
    postTypes() {
      return this.challenge.post_types
    },
    goals() {
      return this.challenge.goals
    },
    currentGroup() {
      return this.goals.filter(
        (item) => item.type === this.postTypes && item.group_id === this.groupId
      )
    },
    achievedPoints() {
      return this.currentGroup.achieved || 0
    },
    statusUpdates() {
      const groupId = this.groupId
      const groupsData = this.$store.state.challenges.groupsData
      return groupsData && groupsData[groupId]
        ? groupsData[groupId].statusUpdates
        : []
    },
  },
  created() {
    this.fetchUsers()
  },
  methods: {
    fetchUsers() {
      const params = {
        groupId: this.groupId,
        filter: this.filters,
        page: 1,
        per_page: 10,
        sort: {},
      }

      store.dispatch('adminUsers/fetchLists', params).then((result) => {
        this.groupMembersList = result.data
      })
    },
    setFilterField: debounce(async function(e, field, minLength = 0) {
      const value = (e.target && e.target.value) || e
      this.filters[field] = value.length > minLength ? value : ''
      this.fetchUsers()
    }, 500),
    clearGroupMember() {
      this.groupMember = ''
    },
    setGroupMember(member) {
      this.groupMember = member.name
      this.filters = {
        name: '',
        email: '',
      }
      this.$router.push({
        name: 'user-page',
        params: { userId: member.id },
      })
    },
    fetchMoreStatusUpdates() {
      this.loadingMore = true
      store
        .dispatch('challenges/fetchStatusUpdatesGroup', {
          groupId: this.groupId,
          challengeId: this.challenge.id,
        })
        .then((posts) => {
          this.loadingMore = false
          this.noMorePosts = !posts.length
        })
        .catch(() => {})
    },
  },
}
</script>

<template>
  <div class="py-5 pl-5">
    <div class="flex items-center">
      <span class="mr-4 text-blue-darker text-2xl font-bold">{{
        teamName
      }}</span>
      <v-popover trigger="click" placement="bottom" :auto-hide="true">
        <div
          :class="{ 'text-blue': groupMember }"
          class="w-full flex items-center filter-dropdown"
        >
          <button
            v-if="groupMember"
            class="mr-1 -ml-2 rounded-full hover:bg-blue-lighter"
            @click.prevent="clearGroupMember"
          >
            <BaseIcon name="close" />
          </button>
          <span class="mr-6 truncate">
            {{ groupMember || 'View Team Members' }}
          </span>
        </div>

        <template slot="popover">
          <input
            :value="filters.name"
            class="w-full text-center border-b border-black leading-looser"
            placeholder="Name"
            @input="setFilterField($event, 'name')"
          />
          <input
            :value="filters.email"
            class="w-full text-center border-b border-black leading-looser"
            placeholder="Email"
            @input="setFilterField($event, 'email')"
          />
          <div>
            <div
              v-for="member in groupMembersList"
              :key="member.id"
              class="mt-2 cursor-pointer"
              @click="() => setGroupMember(member)"
            >
              {{ member.name }}
            </div>
          </div>
        </template>
      </v-popover>
    </div>
    <div class="text-blue-darker text-5xl font-bold mb-2"
      >{{ achievedPoints }} Points</div
    >
    <div class="bg-white pb-6 rounded-2xl">
      <PostFeed
        :status-updates="statusUpdates"
        :loading-more="loadingMore"
        :no-more-posts="noMorePosts"
        @fetch-more-status-updates="fetchMoreStatusUpdates"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.itemList:last-child {
  @apply border-none;
}
</style>
